import { Component, ElementRef, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { toBoolean } from 'src/app/services/codeUtils';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { UniqueIDService } from 'src/app/services/unique-id/unique-id.service';
import { WebcontentService } from 'src/app/services/webcontent/webcontent.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})

export class FooterComponent implements OnInit {

  public footerLink: string = 'footer';
  public footerUrl: string;
  public defaultHeight: any;
  public isMobileApp: Boolean = false;
  public resizeHappenedOnce: boolean = false;
  public showHideFooter: boolean;

  constructor(
    private childElement: ElementRef,
    public config: ConfigService,
    public platform: Platform,
    public webcontentService: WebcontentService,
    public uniqueIDService: UniqueIDService,
    public eventsService: EventsService
  ) {
    this.defaultHeight = this.config.getConfig().FEATURE_FOOTER_MIN_DEFAULT_HEIGHT ?? '400px';
    this.showHideFooter = toBoolean(this.config.getConfig().FEATURE_SHOW_HIDE_FOOTER) ?? true;
  }

  ngOnInit() {

    this.getFooterLink();
    this.loadFooter();

    this.isMobileApp = this.platform.is("capacitor") && this.platform.is('ios');

    this.eventsService.subscribe("event:config:reload", () => {
      this.config.isLoaded().then(() => {
        this.getFooterLink();
        this.loadFooter();
      })
    });

    window.addEventListener('message', (event: MessageEvent) => {
      if (event.data.type === 'resizeIframe') {
        var iframe = this.getIframeElement();
        if (iframe && iframe.name === event.data.params.uniqueName) {
          if (!this.isMobileApp)
            iframe.style.height = event.data.params.height + "px";
          else {
            if ((!this.resizeHappenedOnce && event.data.params.height > 0) || this.androidApp(iframe, event)) {
              iframe.style.height = event.data.params.height + 'px';
              this.resizeHappenedOnce = true;
            }
          }
        }
      }
    });
  }
  public androidApp(iframe, event) {
    return this.platform.is('android') && iframe.style.height > event.data.params.height
  }
  protected getIframeElement(): HTMLIFrameElement {
    return this.childElement.nativeElement.getElementsByTagName('iframe')[0];
  }

  public getFooterLink() {
    const footerstub: string = "footer" + this.config.getConfig().FEATURE_APP_STATE_IDENTIFIER;
    let filteredPayload = this.config.getExternalLinks().payload.filter(link => link.code == footerstub);
    if (!!filteredPayload && !!filteredPayload.length) {
      this.footerLink = filteredPayload[0].url;
    } else {
      this.footerLink = "footer-2";
    }
    return;
  }

  public loadFooter() {
    this.footerUrl = this.webcontentService.getDocContentUrl(this.footerLink);
  }

}
